module.exports = __webpack_public_path__ + "static/img/articles-laptop.4f31af0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/articles-laptop.jpg
// module id = S9b0
// module chunks = 1